import React from "react";
import { Alert } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import FocusedFlowPage from "components/FocusedFlowPage";
import { useWizardContext } from "./WizardContext";
import { BIOBANK_ROUTES } from "../../../constants/routes";

const BioSpecimenWizard = ({ Body, Buttons, children }) => {
  const childItems = React.Children.toArray(children);
  const body = Body || childItems[0];
  const buttons = Buttons || childItems[1];
  const location = useLocation();
  const navigate = useNavigate();
  const { encounter } = useWizardContext();
  const returnTo =
    location.state?.returnTo ||
    location.state?.returnUrl ||
    BIOBANK_ROUTES.SAMPLE_COLLECTION;

  const close = () => {
    sessionStorage.removeItem("bioSpecimenFormData");
    navigate(returnTo);
  };

  const milestone =
    encounter?.milestone ||
    encounter?.metadata?.milestone ||
    encounter?.followUpMilestone;
  const isMitra = milestone && /^H(?:[1-9]|10)$/.test(milestone);

  const isMitraInClinic =
    isMitra &&
    (encounter?.status === "IN_CLINIC" ||
      encounter?.metadata?.mailStatus === "IN_CLINIC");

  return (
    <FocusedFlowPage
      onClose={close}
      maxWidth={760}
      hideHeader
      alert={
        isMitraInClinic ? (
          <Alert severity="info">
            This is an In-Clinic Mitra Follow-up. The next phase will be
            automatically scheduled upon completion.
          </Alert>
        ) : null
      }
      actions={buttons}
    >
      {body}
    </FocusedFlowPage>
  );
};

export default BioSpecimenWizard;
